// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".numas-text{display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", "",{"version":3,"sources":["webpack://./component/text/Text.scss"],"names":[],"mappings":"AAEA,YACI,oBAAA,CAEA,eAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":["$text-prefix-cls: numas-text;\n\n.#{$text-prefix-cls} {\n    display: inline-block;\n\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numas-text": "numas-text"
};
export default ___CSS_LOADER_EXPORT___;
